<template>
  <div class="lightbox-wrapper">

    <div class="overlay" :class="{ active : active }" @click="close()"></div>
    <div class="lightbox">
      <div class="lightbox-close" @click="close()">
        <div class="close">
            <span class="close-icon">
              <svg-icon type="icon-close"/>
            </span>
        </div>
      </div>

      <transition :name="transitionName">
        <div class="lightbox-detail__wrp" v-if="showLightbox">
          <SubpageGallery :gallery="gallery" :img-count="3"/>

          <swiper class="city-uni-slider" :options="swiperOption">
            <swiper-slide v-for="dorm in gallery" :key="dorm.id" class="city-uni-slider__item">
              <router-link to="#">
                <div class="img-gen">
                  <img :src="dorm.img" alt="">
                </div>

              </router-link>
            </swiper-slide>
          </swiper>

          <div class="lightbox-detail">
            <div class="lightbox-top">
              <h4 class="lightbox-text">{{ data.detail }}</h4>
              <p class="lightbox-location">
          <span class="lightbox-location__icon">
              <svg-icon type="icon-location"/>
          </span>
                {{ data.location }}
              </p>
            </div>

            <div class="lightbox-middle">
              <div class="lightbox-middle__item" style="flex-grow: 1;">
                <p class="lightbox-middle__title">İLAN SAHİBİ</p>
                <p class="lightbox-middle__text">{{ data.owner }}</p>
              </div>
              <div class="lightbox-middle__item" style="flex-grow: 1.8;">
                <p class="lightbox-middle__title">TELEFON NUMARASI</p>
                <p class="lightbox-middle__text">{{ data.tel }}</p>
              </div>
              <div class="lightbox-middle__item-right" v-if="data.price">
                <p class="lightbox-middle__title--price">{{ data.price }} TL</p>
                <p class="lightbox-middle__text--span">'den başlayan oda fiyatları</p>
              </div>
            </div>

            <div class="lightbox-bottom">
              <h5 class="lightbox-bottom__title">AÇIKLAMA VE BİLGİLER</h5>
              <p class="lightbox-bottom__txt">
                {{ data.text }}
              </p>
            </div>
          </div>
        </div>
      </transition>
      <div class="navigator">
        <button class="navigator__left" :disabled="isBegin" @click="left()">
          <span class="icon">
             <svg-icon type="icon-arrow-long-left"/>
          </span>
        </button>
        <button class="navigator__right" :disabled="isEnd" @click="right()">
          <span class="icon">
           <svg-icon type="icon-arrow-long-right"/>
         </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SubpageGallery from '@/components/SubpageGallery'

export default {
  name: 'NoticeLightBox',
  components: {
    SubpageGallery
  },
  props: {
    data: Object,
    isEnd: Boolean,
    isBegin: Boolean,
    active: Boolean
  },
  data () {
    return {
      gallery: [
        {
          id: 0,
          img: require('@/assets/img/sehir-galeri/5.jpg')
        },
        {
          id: 1,
          img: require('@/assets/img/sehir-galeri/1.jpg')
        },
        {
          id: 2,
          img: require('@/assets/img/sehir-galeri/2.jpg')
        },
        {
          id: 3,
          img: require('@/assets/img/sehir-galeri/3.jpg')
        },
        {
          id: 4,
          img: require('@/assets/img/sehir-galeri/4.jpg')
        }
      ],
      showLightbox: true,
      transitionName: 'lightbox-slide-fade-left',
      swiperOption: {
        slidesPerView: 4,
        speed: 500,
        loop: true,
        spaceBetween: 0,
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: true,
            slidesPerGroup: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.js-uni-slider-next',
          prevEl: '.js-uni-slider-prev'
        }
      }
    }
  },

  methods: {
    close () {
      this.$emit('closeLightBox')
    },
    right () {
      this.$emit('onClickNext')
      this.showLightbox = false
      this.transitionName = 'lightbox-slide-fade-left'
      setTimeout(() => {
        this.showLightbox = true
      }, 300)
    },

    left () {
      this.$emit('onClickPrev')
      this.showLightbox = false
      this.transitionName = 'lightbox-slide-fade-right'
      setTimeout(() => {
        this.showLightbox = true
      }, 300)
    }

  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/components/notice";
  //slide fade left

  .lightbox-slide-fade-left-enter-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-left-leave-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-left-enter {
    transform: translateX(100%);
    opacity: 0;
    pointer-events: none;
  }

  .lightbox-slide-fade-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
    pointer-events: none;
  }//slide fade right

  .lightbox-slide-fade-right-enter-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-right-leave-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-right-enter {
    transform: translateX(-100%);
    opacity: 0;
    pointer-events: none;
  }

  .lightbox-slide-fade-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
    pointer-events: none;
  }
</style>
